import { render, staticRenderFns } from "./SubmitEnvelopeToReviewModal.vue?vue&type=template&id=35b9de61&lang=pug"
import script from "./SubmitEnvelopeToReviewModal.vue?vue&type=script&lang=js"
export * from "./SubmitEnvelopeToReviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports